import {Input} from '@main/components/form/form-field/input';
import {Select} from '@main/components/form/form-field/select';
import {NumberInput} from '@main/components/form/form-field/number-input';
import {FileInput} from '@main/components/form/form-field/file-input';
import {PhoneMask} from '@main/components/form/form-field/phone-input';
import {DateInput} from '@main/components/form/form-field/date-input';

/**
 * Инициализируются компоненты ввода.
 *
 * @param {Element} element HTML элемент для поиска.
 * @returns {void}
 */
export const initFormFields = (element) => {
  element.querySelectorAll('.js-form-field').forEach((el) => {
    const input = el.querySelector('.js-form-field-input');
    if (input) {
      switch (input.type) {
        case 'select-multiple':
        case 'select-one':
          return new Select({container: el, input});
        case 'file':
          return new FileInput({container: el, input});

        default:
          if (input.classList.contains('js-form-field-input-number')) {
            return new NumberInput({container: el, input});
          } else if (input.classList.contains('js-date-input')) {
            return new DateInput({container: el, input});
          } else {
            if (input.classList.contains('js-phone-input')) {
              new PhoneMask(input);
            }
            return new Input({container: el, input});
          }
      }
    }
  });
};
initFormFields(document);

document.addEventListener('initFormFields', (e) => {
  if (e.detail) {
    const element = document.querySelector(e.detail);
    if (element) {
      initFormFields(element);
    }
  }
});

window.addEventListener('load', () => {
  document.querySelectorAll("input[type='tel']").forEach((input) => new PhoneMask(input));
});
